import React, { ReactNode } from 'react';

import classes from './InfoBlock.module.scss';

type InfoBlockProps = {
  title: string;
  value: ReactNode;
};

const InfoBlock = ({ title, value }: InfoBlockProps) => {
  return (
    <div className={classes.container}>
      <p className={classes.title}>{title}</p>
      <p className={classes.value}>{value}</p>
    </div>
  );
};

export { InfoBlock };
